// extracted by mini-css-extract-plugin
export var bodySections = "_ba-8";
export var gray = "_ba-7";
export var green = "_ba-4";
export var iconContainer = "_ba-9";
export var iconWidgetContainer = "_ba-1";
export var phoneIcon = "_ba-2";
export var red = "_ba-5";
export var statusDot = "_ba-3";
export var widgetContainer = "_ba-0";
export var yellow = "_ba-6";